import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AlertsContext from "common/providers/alerts";
import UserForm from "./ProfileForm";

function Profile() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const {
    saveItem,
    updateItem,
    item: otherProfile,
    error,
    isFetching,
  }: any = useItem('profiles', id, {
    populate: [
      'user',
      'user.role',
      'avatar',
      'companyLogo',
      'reviews.onUser',
      'reviews.onUser.avatar',
      'reviews.author',
      'reviews.author.avatar',
      'reviews.conversation',
      'reviews.conversation.content',
      'services',
      'address',
    ],
  });

  useEffect(() => {
    if (error) {
      setAlert(
        error === "This attribute must be unique"
          ? t("common.emailAlreadyTaken")
          : t("common.error"),
        "danger"
      );
    }
  }, [error, setAlert, t]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/profiles");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataProfile: any) => {
      const profile = { ...dataProfile };

      try {
        if (profile.id) {
          await updateItem(profile.id, profile);
        } else {
          await saveItem(profile);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !otherProfile) ? null : (
    <UserForm onSubmit={onSubmit} editedUser={otherProfile} />
  );
}

export default Profile;
